import { Box, SxProps, Typography } from "@mui/material";
import { ReactElement, ReactNode } from "react";

import { FlexBox } from "~frontend/components/FlexBox";

export const StepInstructions = ({
  header,
  children,
}: {
  header: string;
  children?: ReactNode;
  sx?: SxProps;
}): ReactElement => {
  return (
    <>
      <Typography
        variant="h0Bold"
        sx={{ pb: 1 }}
        data-testid="step-instruction-heading"
      >
        {header}
      </Typography>
      <Typography variant="h2">
        <FlexBox direction="column" gap={2}>
          {children || <Box />}
        </FlexBox>
      </Typography>
    </>
  );
};
